/*
 * Self-hosted points panel (replaces Smile.io's panel, Bin 2026-10-05: identical look and flow).
 * Config: snippets/prex-loyalty.liquid (window.PrexPointsConfig). Backend: edge function `loyalty`.
 * Opens on any link to #smile-home (the header gift icon) or when the URL hash is #smile-home.
 */
(function () {
  'use strict';
  var cfg = window.PrexPointsConfig;
  var root = document.getElementById('prex-pts');
  if (!cfg || !root || window.PrexPoints) return;

  // Program rules as shown by Smile (copy is verbatim).
  // Bin 2026-10-28 (USD points): every account has a points currency (summary.currency, CAD or USD).
  // 100 Points = 1 unit of it, earning is 2 / 5 / 10 Points per unit, and the tier thresholds and
  // referral amounts are set per currency. Guests follow the storefront currency (USD -> USD rules,
  // anything else -> CAD). summary.tiers / summary.referral_terms win when the backend sends them.
  // Keep these values identical to prex-account-ext.
  var RULES = {
    CAD: { tiers: { Bronze: 0, Silver: 500, Gold: 3000 }, friend: 15, minimum: 60, advocate: 15 },
    USD: { tiers: { Bronze: 0, Silver: 350, Gold: 2200 }, friend: 10, minimum: 45, advocate: 10 }
  };
  var TIERS = [
    { name: 'Bronze', rate: 2, bonus: 0, perk: null },
    { name: 'Silver', rate: 5, bonus: 500, perk: 'Priority for limited & allocated items' },
    { name: 'Gold', rate: 10, bonus: 1000, perk: 'Top priority for limited & allocated items' }
  ];
  var EARN = [
    { icon: 'bag', title: 'Place an order', sub: function (t, d) { return t.rate + ' Points for every ' + money(1, cur(d)) + ' spent'; } },
    { icon: 'gift', title: 'Write a Product Review', sub: '100 Points' },
    { icon: 'gift', title: 'Write a review containing photo or video', sub: '200 Points' },
    // Bin 2026-10-24: share-for-points retired (click-counted, farmed weekly); refer a friend instead.
    { icon: 'hand', title: 'Refer a friend', sub: function (t, d) { var r = refTerms(d), c = cur(d);
      return 'Friends get ' + money(r.friend, c) + ' off their first order, you get ' + money(r.advocate, c) + ' store credit'; }, go: 'referrals' }
  ];
  // Where Smile's Share buttons point (read from the live panel 2026-10-06).
  var REF_TEXT = 'Visit P-REX Hobby to receive your free gift!';
  // Bin 2026-10-24: the rules, said out loud (mirrors the Points page REF_RULES and the Rewards Policy page).
  function refRules(d) {
    var r = refTerms(d), c = cur(d);
    return "How it works: your friend must be new to P-REX Hobby, so it has to be their first order, from an email, address and phone number we haven't seen before. Orders of " +
      money(r.minimum, c) + ' or more qualify. Your ' + money(r.advocate, c) + " store credit arrives about two weeks after their order ships, once the return window has passed. Cancelled or refunded orders don't count.";
  }
  // Bin 2026-10-23 (referral review): $15 off the friend's first order of $60+, $15 store credit for the advocate
  // (US$10 off US$45+ / US$10 for USD accounts, Bin 2026-10-28).
  function friendReward(d) { return money(refTerms(d).friend, cur(d)) + ' off their first order'; }
  function advocateReward(d) { return money(refTerms(d).advocate, cur(d)) + ' store credit'; }
  var VIP_DESC = 'Your all access pass to exclusive rewards. Reach higher tiers for more exclusive perks.';

  var ICON = {
    hand: '<svg class="prex-pts-ico" viewBox="0 0 40 40" fill="none"><circle cx="24" cy="12" r="3.2" fill="#DA5D87"/><rect x="7" y="21" width="4" height="11" rx="1.5" fill="#DA5D87"/><path d="M11 23h7l4 2h5a2 2 0 010 4h-6M11 30h11l10-6a2 2 0 00-2-3.5l-6 3" stroke="#333" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    gift: '<svg class="prex-pts-ico" viewBox="0 0 40 40" fill="none"><rect x="9" y="16" width="22" height="7" rx="1" stroke="#333" stroke-width="1.6"/><path d="M11 23v10h18V23" stroke="#333" stroke-width="1.6"/><path d="M20 16v17" stroke="#DA5D87" stroke-width="2"/><path d="M20 16c-2-5-8-6-7-2 .5 2 4 2 7 2zm0 0c2-5 8-6 7-2-.5 2-4 2-7 2z" stroke="#DA5D87" stroke-width="1.6"/></svg>',
    bag: '<svg class="prex-pts-ico" viewBox="0 0 40 40" fill="none"><path d="M11 15h18l1.5 18h-21z" stroke="#333" stroke-width="1.6" stroke-linejoin="round"/><path d="M16 15v-2a4 4 0 018 0v2" stroke="#333" stroke-width="1.6"/><path d="M24 24l5-3 2 4-5 3z" fill="#DA5D87"/></svg>',
    cash: '<svg class="prex-pts-ico" viewBox="0 0 40 40" fill="none"><rect x="8" y="14" width="22" height="13" rx="1.5" transform="rotate(-12 8 14)" stroke="#333" stroke-width="1.6"/><rect x="10" y="17" width="22" height="13" rx="1.5" stroke="#333" stroke-width="1.6" fill="#fff"/><circle cx="21" cy="23.5" r="2.6" stroke="#DA5D87" stroke-width="1.6"/></svg>',
    wallet: '<svg class="prex-pts-ico" viewBox="0 0 40 40" fill="none"><rect x="8" y="13" width="24" height="16" rx="2" stroke="#333" stroke-width="1.6"/><path d="M8 17h24" stroke="#333" stroke-width="1.6"/><rect x="23" y="20" width="9" height="6" rx="1.5" fill="#fff" stroke="#DA5D87" stroke-width="1.6"/><circle cx="27.5" cy="23" r="1.2" fill="#DA5D87"/></svg>',
    history: '<svg class="prex-pts-ico" viewBox="0 0 40 40" fill="none"><path d="M11 20a9 9 0 103-6.7" stroke="#333" stroke-width="1.6" stroke-linecap="round"/><path d="M10 11v4h4" stroke="#333" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 15v6l4 2" stroke="#DA5D87" stroke-width="1.8" stroke-linecap="round"/></svg>',
    x: '<svg class="prex-pts-ico" viewBox="0 0 40 40" fill="none"><path d="M11 11l16 18M27 11L11 29" stroke="#333" stroke-width="1.6" stroke-linecap="round"/><circle cx="30" cy="28" r="2" fill="#DA5D87"/></svg>',
    fb: '<svg class="prex-pts-ico" viewBox="0 0 40 40"><circle cx="19" cy="19" r="10" fill="#333"/><path d="M20.5 29v-7h2.3l.4-2.8h-2.7v-1.7c0-.8.3-1.3 1.4-1.3h1.4v-2.5c-.3 0-1.1-.1-2-.1-2 0-3.3 1.2-3.3 3.4v2.2H16V22h2.2v7z" fill="#fff"/><circle cx="31" cy="29" r="2" fill="#DA5D87"/></svg>',
    fbSq: '<svg width="30" height="30" viewBox="0 0 30 30"><rect x="2" y="2" width="26" height="26" rx="2" fill="#333"/><path d="M20.5 28V18.5h3.2l.5-3.7h-3.7v-2.4c0-1.1.3-1.8 1.8-1.8h2V7.3c-.3 0-1.5-.2-2.9-.2-2.9 0-4.8 1.7-4.8 5v2.7h-3.2v3.7h3.2V28z" fill="#fff"/></svg>',
    xLogo: '<svg width="30" height="30" viewBox="0 0 30 30"><path d="M5 5h6.2l5 7 6.1-7h2.2l-7.3 8.4L25 25h-6.2l-5.4-7.5L6.9 25H4.7l7.7-8.9z" fill="none" stroke="#333" stroke-width="1.3" stroke-linejoin="round"/></svg>',
    mail: '<svg width="30" height="30" viewBox="0 0 30 30"><path d="M4 8h22v15H4z" fill="#333"/><path d="M4 8l11 8.5L26 8" fill="none" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    whatsapp: '<svg width="30" height="30" viewBox="0 0 30 30"><path d="M15 4a11 11 0 0 0-9.5 16.5L4 26l5.7-1.5A11 11 0 1 0 15 4z" fill="none" stroke="#333" stroke-width="1.6" stroke-linejoin="round"/><path d="M11 10.5c.3-.6 1.2-.6 1.5 0l.8 1.8c.2.4 0 .8-.3 1.1l-.6.6c.8 1.6 2 2.8 3.6 3.6l.6-.6c.3-.3.7-.5 1.1-.3l1.8.8c.6.3.6 1.2 0 1.5-1 .8-2.4 1-3.5.5a10 10 0 0 1-5.5-5.5c-.5-1.1-.3-2.5.5-3.5z" fill="#333"/></svg>',
    line: '<svg width="30" height="30" viewBox="0 0 30 30"><path d="M15 5C8.9 5 4 9 4 13.9c0 4.4 3.9 8 9.1 8.7.4.1.9.2.9.6l-.1 1.7c0 .5.4.6.8.4 3.1-1.6 7.3-4.7 9.4-7.2A8 8 0 0 0 26 13.9C26 9 21.1 5 15 5z" fill="none" stroke="#333" stroke-width="1.6" stroke-linejoin="round"/><path d="M9.5 11.5v5h3M14 11.5v5M16.5 16.5v-5l3 5v-5" fill="none" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    sms: '<svg width="30" height="30" viewBox="0 0 30 30"><path d="M5 7h20v13H12l-5 4v-4H5z" fill="none" stroke="#333" stroke-width="1.6" stroke-linejoin="round"/><circle cx="11" cy="13.5" r="1.3" fill="#333"/><circle cx="15" cy="13.5" r="1.3" fill="#333"/><circle cx="19" cy="13.5" r="1.3" fill="#333"/></svg>',
    share: '<svg width="30" height="30" viewBox="0 0 30 30"><path d="M15 4v13M10 9l5-5 5 5M8 14v10h14V14" fill="none" stroke="#333" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    giftSm: '<svg width="40" height="40" viewBox="0 0 40 40" fill="none"><rect x="9" y="16" width="22" height="7" rx="1" stroke="#333" stroke-width="1.6"/><path d="M11 23v10h18V23" stroke="#333" stroke-width="1.6"/><path d="M20 16v17" stroke="#DA5D87" stroke-width="2"/><path d="M20 16c-2-5-8-6-7-2 .5 2 4 2 7 2zm0 0c2-5 8-6 7-2-.5 2-4 2-7 2z" stroke="#DA5D87" stroke-width="1.6"/></svg>',
    copy: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none"><rect x="7" y="7" width="11" height="13" rx="1" stroke="#999" stroke-width="1.4"/><path d="M4 15V3h10" stroke="#999" stroke-width="1.4"/></svg>',
    chev: '<svg class="prex-pts-chev" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    back: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12 5l-5 5 5 5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>',
    cloud: '<svg width="120" height="100" viewBox="0 0 120 100" fill="none"><rect x="20" y="10" width="80" height="80" stroke="#ccc" stroke-dasharray="4 4"/><path d="M30 50a8 8 0 0116-2 6 6 0 018 6H30z" stroke="#555" stroke-width="2"/><path d="M66 70a7 7 0 0114-2 5 5 0 017 5H66z" stroke="#555" stroke-width="2"/><path d="M56 40h12M62 48h10M60 64h8" stroke="#ccc" stroke-width="2"/></svg>'
  };

  var state = { stack: ['home'], data: null, activity: null, tab: 'points', tier: null };
  // Store credit to offer for a cart: enough to cover the subtotal (rounded up to 100 points),
  // never more than the balance. Leftover credit stays on the account.
  // subtotal is in the points currency (cartInPoints).
  function creditPreset(balance, subtotal) {
    var need = Math.ceil(Math.max(subtotal, 0.01) / 1) * 100; // dollars -> points, rounded up to the next dollar
    return Math.max(0, Math.min(Math.floor(balance / 100) * 100, need));
  }
  // Any line with a selling plan = a deposit pre-order (Pay in full submits no plan since theme #511).
  function cartHasDeposit(cart) {
    return !!(cart && (cart.items || []).some(function (i) { return i.selling_plan_allocation; }));
  }
  function creditError(err) {
    return /insufficient/.test(err.message) ? "You don't have enough Points for this reward."
      : /usd rate unavailable/.test(err.message) ? (CREDIT_CUR === 'USD' ? 'US' : 'Canadian') + " dollar store credit isn't available right now. Please try again later."
      : /store credit, use it first/.test(err.message) ? err.message : 'Something went wrong. Please try again.';
  }
  // Presentment cents -> CAD dollars (Shopify.currency.rate = shop currency -> active currency).
  function fxToCad(cents) {
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return cents / 100 / (rate > 0 ? rate : 1);
  }
  var me = cfg.customer;
  // Bin 2026-10-28: store credit is issued in the currency being shopped in (Shopify only offers
  // credit in a checkout of its own currency). When that differs from the points currency it is
  // converted at the edge function's rate (summary usd_rate, USD per CAD), so the customer sees
  // the exact amount that lands. No rate = no cross-currency credit offered.
  var SHOP_USD = !!(window.Shopify && Shopify.currency && Shopify.currency.active === 'USD');
  var CREDIT_CUR = SHOP_USD ? 'USD' : 'CAD';
  // Points currency: the account's (summary.currency); guests use the storefront's. A summary without
  // the field comes from a backend that only knows CAD points, so it reads as CAD.
  function cur(d) {
    if (d && (d.currency === 'USD' || d.currency === 'CAD')) return d.currency;
    return me ? 'CAD' : CREDIT_CUR;
  }
  function tierSpend(t, d) {
    var list = d && d.tiers;
    if (list && list.length) for (var i = 0; i < list.length; i++) if (list[i].name === t.name && list[i].spend != null) return Number(list[i].spend);
    return RULES[cur(d)].tiers[t.name] || 0;
  }
  function refTerms(d) {
    var base = RULES[cur(d)], r = d && d.referral_terms;
    return {
      friend: r && r.friend_amount != null ? Number(r.friend_amount) : base.friend,
      minimum: r && r.friend_minimum != null ? Number(r.friend_minimum) : base.minimum,
      advocate: r && r.advocate_amount != null ? Number(r.advocate_amount) : base.advocate
    };
  }
  // Amount v in currency `from` -> currency `to` (CAD / USD) at summary usd_rate; null when unknown.
  function convert(v, from, to, d) {
    if (from === to) return v;
    var r = d && Number(d.usd_rate);
    if (!(r > 0)) return null;
    return Math.round((from === 'CAD' ? v * r : v / r) * 100) / 100;
  }
  function canCredit(d) { return cur(d) === CREDIT_CUR || !!(d && Number(d.usd_rate) > 0); }
  // A points value (points currency) as the store credit it becomes in this checkout's currency.
  function creditMoney(v, d) {
    var x = convert(v, cur(d), CREDIT_CUR, d);
    return x == null ? money(v, cur(d)) : money(x, CREDIT_CUR);
  }
  // Cart subtotal (presentment cents) in the points currency, for the preset.
  function cartInPoints(cents, d) {
    var pc = cur(d), units = cents / 100, active = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (active === pc) return units;
    var cad = active === 'CAD' ? units : (active === 'USD' && Number(d && d.usd_rate) > 0 ? units / Number(d.usd_rate) : fxToCad(cents));
    if (pc === 'CAD') return cad;
    var usd = convert(cad, 'CAD', 'USD', d);
    return usd == null ? cad : usd;
  }
  function per(d) { return '100 Points = ' + money(1, cur(d)); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }
  // Bin 2026-10-28: loyalty money always carries its currency, "US$7" / "CA$7", never a bare "$".
  function money(n, c) {
    var v = Number(n || 0);
    return (c === 'USD' ? 'US$' : 'CA$') + v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  // Smile's activity lists use a short UTC date: "Oct 17, 2026".
  function shortDate(iso) { return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }); }
  function date(iso) { return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }); }
  function tierOf(name) { for (var i = 0; i < TIERS.length; i++) if (TIERS[i].name === name) return TIERS[i]; return TIERS[0]; }

  function api(action, extra) {
    var body = { action: action, owner: { customer_id: me.id, sig: me.sig } };
    for (var k in extra || {}) body[k] = extra[k];
    return fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.error || r.status); return j; }); });
  }

  // Rows with click attrs (data-go / data-tier / data-reward) are buttons; plain info rows
  // (earn rules, share rows whose button sits on the right) are divs so they don't show a
  // hand cursor (Bin 2026-10-23: 不能点的地方光标不该变成小手).
  function row(icon, title, sub, attrs, right) {
    var tag = attrs ? 'button' : 'div';
    return '<' + tag + ' class="prex-pts-row' + (attrs ? '' : ' prex-pts-row-static') + '" ' + (attrs || '') + '>' + (icon || '') +
      '<span class="prex-pts-row-main"><div class="prex-pts-row-title">' + esc(title) + '</div>' +
      (sub ? '<div class="prex-pts-row-sub">' + esc(sub) + '</div>' : '') + '</span>' + (right == null ? ICON.chev : right) + '</' + tag + '>';
  }
  function tierImg(name) { return '<img src="' + cfg.img[name] + '" alt="" width="40" height="40">'; }

  function hero(d) {
    var big = d && d.balance > 0;
    return '<div class="prex-pts-hero"><div class="prex-pts-hero-img" style="--prex-pts-banner:url(' + cfg.img.banner + ')"></div>' +
      '<div class="prex-pts-hero-text">' + (big
        ? '<div class="prex-pts-hero-sub">Your Points</div><div class="prex-pts-hero-title">' + money(d.balance / 100, cur(d)) + '</div>' +
          '<div class="prex-pts-hero-sub">' + fmt(d.balance) + ' Points</div>' +
          (d.expires_at ? '<div class="prex-pts-hero-chip">Expiration date: ' + date(d.expires_at) + '</div>' : '')
        : '<div class="prex-pts-hero-sub">Welcome to</div><div class="prex-pts-hero-title">P-REX Points</div>') +
      '</div></div><button class="prex-pts-icon-btn prex-pts-close-float" data-close aria-label="Close">' + ICON.close + '</button>';
  }
  function bar(d) {
    // Bin 2026-10-21 (B8): dollars first, points after, e.g. "$17.86 (1,786 pts)".
    var title = me && d ? money(d.balance / 100, cur(d)) + ' (' + fmt(d.balance) + ' pts)' : 'P-REX Points';
    return '<div class="prex-pts-bar"><button class="prex-pts-icon-btn" data-back aria-label="Back">' + ICON.back + '</button>' +
      '<div class="prex-pts-bar-title"><div>' + title + '</div>' + (me && d ? '<div>' + esc(d.tier) + '</div>' : '') + '</div>' +
      '<button class="prex-pts-icon-btn" data-close aria-label="Close">' + ICON.close + '</button></div>';
  }

  // VIP progress line + bar, worded with Smile's templates (built server-side in d.vip).
  function vipProgress(d) {
    var v = d.vip, nt = d.next_tier;
    if (!v && nt) v = { message: 'Spend ' + money(nt.spend_needed, cur(d)) + ' by ' + date(nt.deadline + 'T12:00:00') + ' to reach ' + nt.name,
      show_progress: true, progress: nt.progress };
    if (!v) return '';
    return '<div class="prex-pts-card-head prex-pts-row-sub">' + esc(v.message) + '</div>' +
      (v.show_progress ? '<div class="prex-pts-progress"><div style="width:' + Math.round(v.progress * 100) + '%"></div></div>' : '');
  }
  function memberUntil(d) { return d.vip && d.vip.member_until ? 'Member until ' + d.vip.member_until : ''; }

  function vipCard(d) {
    return '<div class="prex-pts-card">' + row(tierImg(d.tier), d.tier, memberUntil(d), 'data-go="vip"') + vipProgress(d) + '</div>';
  }

  function homeMember(d) {
    var h = '';
    // Bin 2026-10-28: accounts moved to US-dollar points see one line about it for 60 days.
    var sw = d.currency === 'USD' && d.switched_at ? Date.parse(d.switched_at) : NaN;
    if (sw && Date.now() - sw < 60 * 864e5) h += '<div class="prex-pts-card"><div class="prex-pts-card-head prex-pts-center">Your points are now in US dollars.</div></div>';
    if (d.rewards.length) h += '<div class="prex-pts-card">' + row('', 'Your rewards',
      'You have ' + d.rewards.length + ' reward' + (d.rewards.length > 1 ? 's' : '') + ' available', 'data-go="rewards"') + '</div>';
    h += '<div class="prex-pts-card">';
    if (d.balance === 0) {
      h += '<div class="prex-pts-card-head">' + money(0, cur(d)) + ' (0 pts)</div>';
      if (!d.rewards.length) h += '<div class="prex-pts-card-head prex-pts-row-sub">Next reward</div>' +
        row(ICON.wallet, 'Store credit', per(d), 'data-go="redeem"', '');
    } else if (d.balance < 100 && !d.rewards.length) {
      h += '<div class="prex-pts-card-head prex-pts-row-sub">Next reward</div>' +
        row(ICON.wallet, 'Store credit', per(d), 'data-go="redeem"', ring(d.balance / 100));
    }
    h += row(ICON.hand, 'Ways to earn', '', 'data-go="earn"') + row(ICON.gift, 'Ways to redeem', '', 'data-go="redeem"') + '</div>';
    h += vipCard(d);
    if (d.referral) h += '<div class="prex-pts-card">' + row('', 'Refer your friends', d.referral.completed + ' referral' +
      (d.referral.completed === 1 ? '' : 's') + ' completed', 'data-go="referrals"') +
      '<p class="prex-pts-ref-desc">Share this URL to give your friends the reward ' + friendReward(d) + '</p>' + refShare(d.referral) + '</div>';
    h += '<div class="prex-pts-card">' + row(ICON.history, 'Your activity', '', 'data-go="activity"') + '</div>';
    return h;
  }

  function ring(p) {
    var c = 2 * Math.PI * 9, off = c * (1 - Math.max(0, Math.min(1, p)));
    return '<svg class="prex-pts-ring" viewBox="0 0 22 22" width="22" height="22" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="9" fill="none" stroke="#e6e6e6" stroke-width="2"/>' +
      '<circle cx="11" cy="11" r="9" fill="none" stroke="#DA5D87" stroke-width="2" stroke-linecap="round" stroke-dasharray="' + c.toFixed(2) +
      '" stroke-dashoffset="' + off.toFixed(2) + '" transform="rotate(-90 11 11)"/></svg>';
  }

  function refShare(r) {
    return '<div class="prex-pts-ref-url"><input readonly tabindex="-1" value="' + esc(r.url) + '"><button data-copy="' + esc(r.url) +
      '" aria-label="Copy referral link">' + ICON.copy + '</button></div><div class="prex-pts-ref-btns">' +
      '<button data-refshare="whatsapp" aria-label="share on WhatsApp">' + ICON.whatsapp + '<div>WhatsApp</div></button>' +
      '<button data-refshare="line" aria-label="share on LINE">' + ICON.line + '<div>LINE</div></button>' +
      '<button data-refshare="sms" aria-label="share by text message">' + ICON.sms + '<div>SMS</div></button>' +
      '<button data-refshare="x" aria-label="share on X">' + ICON.xLogo + '<div>X</div></button>' +
      '<button data-refshare="facebook" aria-label="share on Facebook">' + ICON.fbSq + '<div>Facebook</div></button>' +
      '<button data-go="ref-email" aria-label="share by email">' + ICON.mail + '<div>Email</div></button>' +
      (navigator.share ? '<button data-refshare="native" aria-label="more sharing options">' + ICON.share + '<div>More</div></button>' : '') +
      '</div><p class="prex-pts-ref-hint">Instagram, Discord or WeChat: copy the link and paste it into a message.</p>';
  }

  function referralsPage(d) {
    return '<div class="prex-pts-page-title">Referrals</div><p class="prex-pts-ref-intro">Give your friends a reward and claim your own when they make a purchase.</p>' +
      '<div class="prex-pts-card">' + row(ICON.cash, 'They get', friendReward(d) + ' (' + money(refTerms(d).minimum, cur(d)) + ' minimum)', '', '') + row(ICON.cash, 'You get', advocateReward(d) + ' when they order', '', '') + '</div>' +
      '<div class="prex-pts-ref-sec"><div class="prex-pts-sec" style="margin-left:0">Your referral link</div>' + refShare(d.referral) +
      '<p class="prex-pts-ref-hint prex-pts-ref-rules">' + esc(refRules(d)) + '</p></div>';
  }

  function refEmailPage() {
    return '<div class="prex-pts-page-title">Refer your friends by email</div><form class="prex-pts-ref-form" data-refmail>' +
      '<label>To</label><textarea name="to" rows="3" placeholder="Separate each email with a comma."></textarea>' +
      '<label>Message</label><textarea name="msg" rows="5" placeholder="Personalize your referral message for your friends. We\'ll take care of adding the offer link for you."></textarea>' +
      '<div class="prex-pts-center"><button type="submit" class="prex-pts-btn-grey">Send email</button></div></form>';
  }

  function homeGuest() {
    return '<div class="prex-pts-card prex-pts-center"><h3>Become a member</h3><p class="prex-pts-desc">With more ways to unlock exciting perks, this is your all access pass to exclusive rewards.</p>' +
      '<a class="prex-pts-btn" href="' + esc(cfg.registerUrl) + '">Join now</a>' +
      '<p class="prex-pts-desc" style="margin-top:12px">Already have an account? <a class="prex-pts-link" href="' + esc(cfg.loginUrl) + '">Sign in</a></p></div>' +
      '<div class="prex-pts-card"><h3>Points</h3><p class="prex-pts-desc">Earn more Points for different actions, and turn those Points into awesome rewards!</p>' +
      row(ICON.hand, 'Ways to earn', '', 'data-go="earn"') + row(ICON.gift, 'Ways to redeem', '', 'data-go="redeem"') + '</div>' +
      '<div class="prex-pts-card"><h3>VIP</h3><p class="prex-pts-desc">' + VIP_DESC + '</p>' +
      TIERS.map(function (t) { return row(tierImg(t.name), t.name, 'Spend ' + money(tierSpend(t, null), cur(null)), 'data-tier="' + t.name + '"'); }).join('') + '</div>';
  }

  function earnPage(d) {
    var t = tierOf(d ? d.tier : 'Bronze');
    return '<div class="prex-pts-page-title">Ways to earn</div><div class="prex-pts-card">' +
      EARN.map(function (e) {
        var sub = typeof e.sub === 'function' ? e.sub(t, d) : e.sub;
        var right = '';
        return row(ICON[e.icon], e.title, sub, e.go && me ? 'data-go="' + e.go + '"' : '', right);
      }).join('') + '</div>';
  }

  function redeemPage(d) {
    var can = d && d.balance >= 100;
    // Bin 2026-10-21: a second way to redeem, points -> Shopify store credit (no code, applied at checkout).
    // Bin 2026-10-21 ("点击没有反应"): the rows themselves are clickable too. Guests go to sign-in;
    // members with fewer than 100 Points still open the page, which tells them how many more they need.
    var go = function (view) { return me ? 'data-go="' + view + '"' : 'data-login'; };
    // Bin 2026-10-21 ("收成一条，只留 store credit"): one way to redeem. The discount-code route
    // (redeem-detail / codePage) stays in the code for customer service and for codes already issued.
    var view = can ? '<span class="prex-pts-btn prex-pts-btn-sm">View</span>' : '';
    // 2026-10-21 (evening, Bin): still one row. Shopify refuses store credit on carts holding a
    // deposit pre-order ("deferred purchase option"), so the cart card / drawer strip silently
    // switch to a one-time code for those carts (cartHasDeposit); the customer sees one button.
    return '<div class="prex-pts-page-title">Ways to redeem</div><div class="prex-pts-card">' +
      row(ICON.wallet, 'Store credit', per(d) + ' · No code, works on any item, applied at checkout', go('credit-detail'), view) + '</div>';
  }

  function needMore(d) {
    return '<p class="prex-pts-note">You have ' + fmt(d.balance) + ' Points. You need ' + fmt(100 - d.balance) + ' more to redeem.</p>';
  }

  function rewardsPage(d) {
    return '<div class="prex-pts-page-title">Your rewards</div><div class="prex-pts-card">' +
      d.rewards.map(function (r, i) { return row(ICON.cash, money(r.amount, r.currency || cur(d)) + ' off coupon', 'Spent ' + fmt(r.points) + ' Points', 'data-reward="' + i + '"'); }).join('') + '</div>';
  }

  // Bin 2026-10-23: the code route is back as a secondary option (store credit needs the customer signed
  // in at checkout and hides inside Shop Pay's collapsed Payment row; a code works anywhere). Say what
  // the code gives up compared with credit.
  function codeNote(d) {
    return 'A one-time code for a single order, up to ' + money(MAX_REDEEM / 100, cur(d)) + ' per code. Works in any checkout, Shop Pay included, and stacks with free shipping codes but not with other discount codes. Any amount not used on that order is not returned, and it does not apply to Lucky Box.';
  }
  // Store credit accounts are per currency (CAD here): Shopify only offers it when the checkout is in CAD
  // (verified 2026-10-21: a US address / USD checkout does not show it), so say so.
  // Bin 2026-10-21: converted credit expires 365 days after conversion (edge fn passes expiresAt).
  // Bin 2026-10-21: US-address customers get USD credit at Shopify's rate (web #759), everyone else CAD.
  // Shopify does not deduct store credit by itself: the checkout shows an "Apply store credit" button the
  // customer taps (Taekyung 2026-10-23: "the $64 didn't come off"). Say so instead of "automatically".
  // Bin 2026-10-28: name only the currency this customer deals in (US visitors never read "CAD").
  function creditNote(d) {
    var name = CREDIT_CUR === 'USD' ? 'US dollars' : 'Canadian dollars';
    var issued = cur(d) === CREDIT_CUR ? 'Issued in ' + name + ', so it shows when you check out in ' + CREDIT_CUR + '.'
      : 'Issued in the currency you are shopping in (' + name + ', at the current rate), so it shows when you check out in ' + CREDIT_CUR + '.';
    return 'Store credit shows on the checkout page: tap Apply store credit to use it, no code needed. Works on any item, including sale items and pre-orders. Carts with a deposit pre-order get the same value as a one-time code, applied for you. ' +
      issued + ' Valid for 12 months.';
  }
  // Bin 2026-10-21 (evening): no per-conversion cap on store credit (the $50 cap was a discount-code rule).
  var MAX_REDEEM = 5000;

  function redeemDetailPage(d) {
    if (d.balance < 100) return '<div class="prex-pts-card prex-pts-boxed" style="margin-top:24px">' + row(ICON.cash, 'Order discount', per(d), '', '') +
      '<p class="prex-pts-note">' + codeNote(d) + '</p>' + needMore(d) +
      '<div class="prex-pts-center"><button class="prex-pts-btn" data-go="earn">Ways to earn</button></div></div>';
    var max = Math.min(MAX_REDEEM, Math.floor(d.balance / 100) * 100);
    // Smile opens the slider at the maximum the customer can redeem.
    var pts = Math.min(Math.max(state.redeemPts || max, 100), max);
    state.redeemPts = pts;
    return '<div class="prex-pts-card prex-pts-boxed" style="margin-top:24px">' + row(ICON.cash, 'Order discount', per(d), '', '') +
      '<p class="prex-pts-note">' + codeNote(d) + '</p>' +
      '<div class="prex-pts-center prex-pts-slider-label">' + fmt(pts) + ' Points for ' + money(pts / 100, cur(d)) + ' off</div>' +
      '<input class="prex-pts-slider" type="range" min="100" max="' + max + '" step="100" value="' + pts + '" data-slider' + (max <= 100 ? ' disabled' : '') + '>' +
      '<div class="prex-pts-center"><button class="prex-pts-btn" data-redeem' + (state.busy ? ' disabled' : '') + '>' + (state.busy ? '…' : 'Redeem') + '</button></div>' +
      (state.err ? '<p class="prex-pts-note" style="color:#c0392b">' + esc(state.err) + '</p>' : '') + '</div>';
  }

  // Store credit: same card as the discount slider, "Add to store credit" instead of "Redeem".
  function creditDetailPage(d) {
    if (d.balance < 100) return '<div class="prex-pts-card prex-pts-boxed" style="margin-top:24px">' + row(ICON.wallet, 'Store credit', per(d), '', '') +
      '<p class="prex-pts-note">' + creditNote(d) + '</p>' + needMore(d) +
      '<div class="prex-pts-center"><button class="prex-pts-btn" data-go="earn">Ways to earn</button></div></div>';
    var max = Math.floor(d.balance / 100) * 100;
    var pts = Math.min(Math.max(state.redeemPts || max, 100), max);
    state.redeemPts = pts;
    return '<div class="prex-pts-card prex-pts-boxed" style="margin-top:24px">' + row(ICON.wallet, 'Store credit', per(d), '', '') +
      '<p class="prex-pts-note">' + creditNote(d) + '</p>' +
      '<div class="prex-pts-center prex-pts-slider-label">' + fmt(pts) + ' Points for ' + creditMoney(pts / 100, d) + ' store credit</div>' +
      '<input class="prex-pts-slider" type="range" min="100" max="' + max + '" step="100" value="' + pts + '" data-slider data-unit="store credit"' + (max <= 100 ? ' disabled' : '') + '>' +
      '<div class="prex-pts-center"><button class="prex-pts-btn" data-credit' + (state.busy || !canCredit(d) ? ' disabled' : '') + '>' + (state.busy ? '…' : 'Add to store credit') + '</button></div>' +
      (state.err ? '<p class="prex-pts-note" style="color:#c0392b">' + esc(state.err) + '</p>' : '') +
      // Bin 2026-10-23: secondary route for customers who want something that works in any checkout.
      '<p class="prex-pts-note prex-pts-center" style="margin-top:12px"><button type="button" class="prex-pts-link" style="background:none;border:0;padding:0;font:inherit;cursor:pointer" data-go="redeem-detail">Prefer a one-time discount code instead?</button></p></div>';
  }

  // r.currency / r.credit_amount = what was issued (the checkout currency); r.store_credit is in it too.
  function creditedPage(r) {
    var ic = r.currency === 'USD' || r.currency === 'CAD' ? r.currency : CREDIT_CUR;
    var issued = r.credit_amount != null ? r.credit_amount : r.amount;
    return '<div class="prex-pts-card prex-pts-boxed" style="margin-top:24px">' + row(ICON.wallet, money(issued, ic) + ' store credit', 'Spent ' + fmt(r.points) + ' Points', '', '') +
      '<p class="prex-pts-center" style="margin:12px 0">Added to your account. You now have ' + money(r.store_credit, ic) + ' store credit.</p>' +
      '<p class="prex-pts-note">' + creditNote(state.data) + '</p>' +
      '<a class="prex-pts-btn prex-pts-btn-wide" href="/checkout">Go to checkout</a></div>';
  }

  function codePage(r) {
    return '<div class="prex-pts-card prex-pts-boxed" style="margin-top:24px">' + row(ICON.cash, money(r.amount, r.currency || cur(state.data)) + ' off coupon', 'Spent ' + fmt(r.points) + ' Points', '', '') +
      '<p class="prex-pts-center" style="margin:12px 0">Use this discount code on your next order!</p>' +
      '<div class="prex-pts-code"><span>' + esc(r.code) + '</span><button data-copy="' + esc(r.code) + '" aria-label="Copy">' + ICON.copy + '</button></div>' +
      '<p class="prex-pts-note">' + codeNote(state.data) + '</p>' +
      '<a class="prex-pts-btn prex-pts-btn-wide" href="/discount/' + encodeURIComponent(r.code) + '?redirect=/cart">Apply code</a></div>';
  }

  function vipPage(d) {
    var p = vipProgress(d);
    return '<div class="prex-pts-page-title">VIP status</div><div class="prex-pts-card">' + row(tierImg(d.tier), d.tier, memberUntil(d), '', '') + '</div>' +
      (p ? '<div style="border-top:1px solid #e6e6e6"></div>' + p : '') +
      '<div class="prex-pts-card"><h3>VIP tiers</h3><p class="prex-pts-desc">' + VIP_DESC + '</p>' +
      TIERS.map(function (t) { return row(tierImg(t.name), t.name, 'Spend ' + money(tierSpend(t, d), cur(d)), 'data-tier="' + t.name + '"'); }).join('') + '</div>';
  }

  function tierPage() {
    var t = tierOf(state.tier), d = state.data, c = cur(d);
    var perks = [];
    if (t.perk) perks.push(t.perk);
    if (t.bonus) perks.push(fmt(t.bonus) + ' Points');
    perks.push('Place an order - ' + t.rate + ' Points for every ' + money(1, c) + ' spent');
    return '<div class="prex-pts-card" style="margin-top:24px">' + row(tierImg(t.name), t.name, 'Spend ' + money(tierSpend(t, d), c), '', '') +
      '<div class="prex-pts-card-head" style="font-weight:600;margin-top:8px">Benefits</div>' +
      perks.map(function (p) { return '<div class="prex-pts-card-head" style="border-top:1px solid #e6e6e6">' + esc(p) + '</div>'; }).join('') + '</div>';
  }

  var EMPTY = {
    points: ['No Points activity', "You haven't earned any Points yet.", 'How do I earn Points?', 'earn'],
    vip: ['No VIP activity', "You don't have any VIP activity yet.", 'Learn more about VIP tiers', 'vip'],
    referrals: ['No referral history', "You haven't made any referrals yet.", 'How do I make a referral?', 'referrals']
  };
  var KIND = { order_earn: 'Placed an order', order_reverse: 'Order refunded', review: 'Wrote a review', tier_bonus: 'Reached a new VIP tier',
    redeem: 'Redeemed points', redeem_refund: 'Reward returned', expiry: 'Points expired', manual: 'Points adjusted', opening: 'Points balance' };

  function activityPage() {
    var a = state.activity;
    var tabs = '<div class="prex-pts-tabs">' + ['points', 'vip', 'referrals'].map(function (k) {
      return '<button class="prex-pts-tab' + (state.tab === k ? ' is-on' : '') + '" data-tab="' + k + '">' + (k === 'points' ? 'Points' : k === 'vip' ? 'VIP' : 'Referrals') + '</button>';
    }).join('') + '</div>';
    if (!a) return '<div class="prex-pts-page-title">Activity</div>' + tabs + '<div class="prex-pts-loading">Loading…</div>';
    var list = state.tab === 'points' ? a.points : state.tab === 'vip' ? a.vip : (a.referrals || []);
    if (!list.length) {
      var e = EMPTY[state.tab];
      return '<div class="prex-pts-page-title">Activity</div>' + tabs + '<div class="prex-pts-empty">' + ICON.cloud + '<strong>' + e[0] + '</strong><div>' + e[1] + '</div>' +
        '<p><a class="prex-pts-link" href="#" ' + (e[3] && (e[3] !== 'referrals' || (state.data && state.data.referral)) ? 'data-go="' + e[3] + '"' : '') + '>' + e[2] + '</a></p></div>';
    }
    // Same layout as Smile's panel: title / sub line on the left, short date on the right.
    function line(title, sub, at, cls) {
      return '<div class="prex-pts-row prex-pts-act' + (cls ? ' ' + cls : '') + '"><span class="prex-pts-row-main"><div class="prex-pts-row-title">' + esc(title) +
        '</div>' + (sub ? '<div class="prex-pts-row-sub">' + esc(sub) + '</div>' : '') + '</span><span class="prex-pts-act-date">' + shortDate(at) + '</span></div>';
    }
    var body, banner = '';
    if (state.tab === 'referrals') body = list.map(function (r) {
      return line(r.friend, r.state || (r.status === 'completed' ? 'Completed' : 'Pending'), r.created_at, r.cancelled ? 'is-muted' : '');
    }).join('');
    else if (state.tab === 'vip') body = list.map(function (r) { return line(r.description || 'VIP', '', r.created_at); }).join('');
    else {
      banner = '<div class="prex-pts-banner">Your points balance may not reflect your latest activity</div>';
      body = list.map(function (r) {
      var n = Math.abs(r.delta);
      return line(r.description != null ? r.description : (KIND[r.kind] || r.note || 'Points'),
        (r.delta < 0 ? '- ' : '+ ') + fmt(n) + ' ' + (n === 1 ? 'Point' : 'Points'), r.created_at);
      }).join('');
    }
    return '<div class="prex-pts-page-title">Activity</div>' + tabs + banner + '<div class="prex-pts-card">' + body + '</div>';
  }

  function render() {
    var view = state.stack[state.stack.length - 1];
    var d = state.data;
    var html;
    if (me && !d) html = hero(null) + '<div class="prex-pts-body"><div class="prex-pts-card prex-pts-loading">Loading…</div></div>';
    else if (view === 'home') html = hero(d) + '<div class="prex-pts-body">' + (me ? homeMember(d) : homeGuest()) + '</div>';
    else {
      var page = view === 'earn' ? earnPage(d) : view === 'redeem' ? redeemPage(d) : view === 'rewards' ? rewardsPage(d)
        : view === 'vip' ? vipPage(d) : view === 'tier' ? tierPage() : view === 'activity' ? activityPage()
        : view === 'redeem-detail' ? redeemDetailPage(d) : view === 'code' ? codePage(state.code)
        : view === 'credit-detail' ? creditDetailPage(d) : view === 'credited' ? creditedPage(state.credited)
        : view === 'referrals' ? referralsPage(d) : view === 'ref-email' ? refEmailPage() : '';
      html = bar(d) + '<div class="prex-pts-body">' + page + '</div>';
    }
    // Smile shows the redeem and code screens as a card on the hatched background; other sub-pages are plain white.
    var cls = view === 'home' ? ' prex-pts-home' : (view === 'redeem-detail' || view === 'code' || view === 'credit-detail' || view === 'credited') ? '' : ' prex-pts-sub';
    root.innerHTML = '<div class="prex-pts-scroll' + cls + '">' + html + '</div>';
  }

  function go(view) {
    if (view === 'redeem-detail' || view === 'credit-detail') { state.redeemPts = 0; state.err = null; }
    if (view === 'vip' && !me) { state.tier = 'Bronze'; view = 'tier'; }
    if (view === 'activity' && me && !state.activity) api('activity').then(function (a) { state.activity = a; render(); }).catch(function () {});
    state.stack.push(view); render();
  }

  // `currency` = the storefront currency, a hint the backend uses only for accounts without their own.
  // usd_rate is asked for up front in a USD storefront; a USD account in a CAD storefront asks once more.
  function loadSummary() {
    if (!state.summary) state.summary = api('summary', SHOP_USD ? { usd_rate: true, currency: CREDIT_CUR } : { currency: CREDIT_CUR }).then(function (d) {
      if (cur(d) === CREDIT_CUR || Number(d.usd_rate) > 0) return d;
      return api('summary', { usd_rate: true, currency: CREDIT_CUR }).catch(function () { return d; });
    }).then(function (d) { state.data = d; return d; });
    return state.summary;
  }
  // open('code', reward) / open('redeem') jump straight to a sub-page, like Smile's cart nudges.
  function open(view, reward) {
    state.stack = view ? ['home', view] : ['home'];
    if (reward) state.code = reward;
    root.classList.add('is-open'); render();
    if (me) loadSummary().then(render).catch(function () { state.data = null; me = null; state.stack = ['home']; render(); });
  }
  function copy(text, btn) {
    (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).catch(function () {
      var i = document.createElement('input'); i.value = text; document.body.appendChild(i); i.select(); document.execCommand('copy'); i.remove();
    });
    btn.classList.add('is-copied'); setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
  }

  function doRedeem() {
    if (state.busy) return;
    state.busy = true; state.err = null; render();
    api('redeem', { points: state.redeemPts }).then(function (r) {
      state.busy = false;
      state.data.balance = r.balance;
      state.data.rewards.unshift({ code: r.code, points: r.points, amount: r.amount, currency: r.currency });
      state.code = { code: r.code, points: r.points, amount: r.amount, currency: r.currency };
      state.stack = ['home', 'code']; render();
    }).catch(function (e) {
      state.busy = false;
      state.err = /insufficient/.test(e.message) ? "You don't have enough Points for this reward." : 'Something went wrong. Please try again.';
      render();
    });
  }

  function doCredit() {
    if (state.busy) return;
    state.busy = true; state.err = null; render();
    api('credit', { points: state.redeemPts, currency: CREDIT_CUR }).then(function (r) {
      state.busy = false;
      state.data.balance = r.balance;
      state.activity = null;
      state.credited = r;
      state.stack = ['home', 'credited']; render();
    }).catch(function (e) {
      state.busy = false;
      state.err = creditError(e);
      render();
    });
  }

  function close() { root.classList.remove('is-open'); if (location.hash === '#smile-home') history.replaceState(null, '', location.pathname + location.search); }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-close],[data-back],[data-go],[data-tier],[data-tab],[data-reward],[data-copy],[data-redeem],[data-credit],[data-refshare],[data-login]');
    if (!t) return;
    if (t.hasAttribute('data-login')) { location.href = cfg.loginUrl; return; }
    if (t.hasAttribute('data-close')) return close();
    if (t.hasAttribute('data-back')) { state.stack.pop(); if (!state.stack.length) state.stack = ['home']; return render(); }
    if (t.hasAttribute('data-tab')) { state.tab = t.getAttribute('data-tab'); return render(); }
    if (t.hasAttribute('data-tier')) { state.tier = t.getAttribute('data-tier'); return go('tier'); }
    if (t.hasAttribute('data-reward')) { state.code = state.data.rewards[+t.getAttribute('data-reward')]; return go('code'); }
    if (t.hasAttribute('data-copy')) { copy(t.getAttribute('data-copy'), t); return; }
    if (t.hasAttribute('data-redeem')) { return doRedeem(); }
    if (t.hasAttribute('data-credit')) { return doCredit(); }
    if (t.hasAttribute('data-refshare')) {
      var u = state.data.referral.url, ch = t.getAttribute('data-refshare'), msg = REF_TEXT + ' ' + u;
      if (ch === 'native') { navigator.share({ title: 'P-REX Hobby', text: REF_TEXT, url: u }).catch(function () {}); return; }
      if (ch === 'sms') { location.href = 'sms:?&body=' + encodeURIComponent(msg); return; }
      var href = ch === 'x' ? 'https://x.com/intent/tweet?text=' + encodeURIComponent(REF_TEXT) + '&url=' + encodeURIComponent(u)
        : ch === 'whatsapp' ? 'https://wa.me/?text=' + encodeURIComponent(msg)
        : ch === 'line' ? 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(u) + '&text=' + encodeURIComponent(REF_TEXT)
        : 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(u);
      window.open(href, '_blank', 'noopener,width=600,height=560');
      return;
    }
    e.preventDefault(); go(t.getAttribute('data-go'));
  });
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-refmail]');
    if (!f) return;
    e.preventDefault();
    var to = f.to.value.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!to.length) { f.to.focus(); return; }
    // Sent from the customer's own mail app, so the friend sees who it's from.
    var body = (f.msg.value.trim() ? f.msg.value.trim() + '\n\n' : '') + REF_TEXT + '\n' + state.data.referral.url;
    location.href = 'mailto:' + to.map(encodeURIComponent).join(',') + '?subject=' + encodeURIComponent('A gift for you from P-REX Hobby') +
      '&body=' + encodeURIComponent(body);
  });
  root.addEventListener('input', function (e) {
    if (!e.target.hasAttribute('data-slider')) return;
    state.redeemPts = +e.target.value;
    var l = root.querySelector('.prex-pts-slider-label');
    var unit = e.target.getAttribute('data-unit') || 'off';
    if (l) l.textContent = fmt(state.redeemPts) + ' Points for ' + (unit === 'store credit' ? creditMoney(state.redeemPts / 100, state.data) : money(state.redeemPts / 100, cur(state.data))) + ' ' + unit;
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#smile-home"]');
    if (!a) return;
    e.preventDefault(); root.classList.contains('is-open') ? close() : open();
  });
  if (location.hash === '#smile-home') open();
  // Email deep links. Smile's emails use ?smile_deep_link=<page>; we keep the same parameter
  // so links in emails already sent keep working, and the Klaviyo emails use it too.
  (function () {
    var link = new URLSearchParams(location.search).get('smile_deep_link');
    var view = { points_activity_rules: 'earn', points_products: 'redeem', 'your-rewards': 'rewards', home: null }[link];
    if (view === undefined) return;
    if (view === 'rewards' && me) {
      loadSummary().then(function (d) { open(d.rewards.length ? 'rewards' : null); }).catch(function () { open(); });
    } else open(view === 'rewards' ? null : view);
  })();

  // ── Friend landing (Bin 2026-10-23, one step): a referral link (?ref=CODE, or an old Smile link's
  // ?smile_referral_code=CODE) claims the gift code straight away (CA$15 off CA$60+, or US$10 off US$45+
  // in a USD storefront: one code, the discount follows the checkout currency, Bin 2026-10-28), applies it through /discount/<code>
  // (Shopify keeps it on the cart) and comes back to the same page with a small card. No email form.
  // Visitors who already ordered here skip it: the gift is for first orders.
  function friendLanding() {
    var q = new URLSearchParams(location.search);
    var ref = q.get('ref') || q.get('smile_referral_code');
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('prex_ref_gift') || 'null'); } catch (e) {}
    if (ref) {
      if (!/^[A-Za-z0-9]{4,32}$/.test(ref) || (cfg.ordersCount || 0) > 0) return;
      if (saved && saved.ref === ref && saved.code) return applyGift(saved, q);
      fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'claim_referral', ref: ref, currency: CREDIT_CUR }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.error || ''); return j; }); })
        .then(function (r) {
          saved = { ref: ref, code: r.code, amount: r.amount, minimum: r.minimum, currency: r.currency, at: Date.now() };
          try { localStorage.setItem('prex_ref_gift', JSON.stringify(saved)); } catch (e) {}
          applyGift(saved, q);
        }).catch(function () {});
      return;
    }
    var shown = false;
    try { shown = !!sessionStorage.getItem('prex_ref_shown'); } catch (e) {}
    if (saved && saved.code && !shown && (cfg.ordersCount || 0) === 0) giftCard(saved);
  }
  function applyGift(g, q) {
    q.delete('ref'); q.delete('smile_referral_code');
    var back = location.pathname + (q.toString() ? '?' + q.toString() : '');
    try { sessionStorage.removeItem('prex_ref_shown'); } catch (e) {}
    location.replace('/discount/' + encodeURIComponent(g.code) + '?redirect=' + encodeURIComponent(back));
  }
  // The terms shown follow this storefront's currency: the returned amounts when they were given in it,
  // else the per-currency rules (an older claim, or the visitor has since switched country).
  function giftCard(g) {
    var gc = CREDIT_CUR, base = RULES[gc];
    var same = g.currency ? g.currency === gc : gc === 'CAD';
    var amt = same && g.amount ? g.amount : base.friend, min = same && g.minimum ? g.minimum : base.minimum;
    var box = document.createElement('div');
    box.className = 'prex-pts-friend'; box.id = 'prex-pts-friend'; box.setAttribute('role', 'dialog');
    box.innerHTML = '<button class="prex-pts-friend-x" data-fclose aria-label="Close">' + ICON.close + '</button>' + ICON.giftSm +
      '<div class="prex-pts-friend-title">Your ' + money(amt, gc) + ' gift is ready</div>' +
      '<p class="prex-pts-friend-note">' + money(amt, gc) + ' off your first order of ' + money(min, gc) + ' or more, taken off automatically at checkout. Your code, in case you need it:</p>' +
      '<div class="prex-pts-code"><span>' + esc(g.code) + '</span><button data-fcopy="' + esc(g.code) + '" aria-label="Copy">' + ICON.copy + '</button></div>' +
      '<a class="prex-pts-friend-btn is-on" href="/collections/all">Start shopping</a>';
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-fclose]')) { box.remove(); return; }
      var c = e.target.closest('[data-fcopy]');
      if (c) copy(c.getAttribute('data-fcopy'), c);
    });
    document.body.appendChild(box);
    try { sessionStorage.setItem('prex_ref_shown', '1'); } catch (e) {}
  }
  friendLanding();

  // ── Cart nudges (Smile "Increase reward usage" / "Increase points spending"): on the cart
  // page only, for members. An unused reward wins over the points nudge, as in Smile.
  // Bin 2026-10-21 (B7): one click instead of five. An unused code is applied straight away
  // ("Apply your $X code"); otherwise the button offers a preset ("Use 500 pts for $5 off") =
  // the largest multiple of 100 points that is <= balance, <= the cart subtotal (in the points
  // currency) and <= 5,000.
  // One confirmation, then redeem -> code -> /discount/<code>?redirect=/cart applies it.
  function cartNudge() {
    if (!me || !/^\/cart\/?$/.test(location.pathname)) return;
    try { if (sessionStorage.getItem('prex-pts-nudge-closed')) return; } catch (e) {}
    Promise.all([loadSummary(), fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; })])
      .then(function (res) {
      var d = res[0], cart = res[1];
      var reward = d.rewards[0];
      // The code is already on this cart (we just applied it, or the customer did): nothing to nudge.
      var onCart = (cart && cart.discount_codes || []).map(function (c) { return String(c.code).toLowerCase(); });
      if (reward && onCart.indexOf(String(reward.code).toLowerCase()) >= 0) return;
      // Bin 2026-10-21 ("收成一条"): points become store credit (enough to cover this cart, <= 5,000),
      // then straight to checkout where Shopify offers "Apply store credit". A code issued earlier
      // (before the switch, or by customer service) is still applied as a code.
      var subtotal = cart ? cartInPoints(cart.items_subtotal_price || cart.total_price || 0, d) : 50;
      // A deposit pre-order in the cart: Shopify blocks store credit, so offer a discount code instead.
      var deposit = cartHasDeposit(cart);
      var preset = deposit ? Math.min(creditPreset(d.balance, subtotal), MAX_REDEEM) : creditPreset(d.balance, subtotal);
      // Codes are valued in the points currency; store credit in this checkout's currency (creditMoney).
      var pc = cur(d), rc = reward ? reward.currency || pc : pc;
      if (!reward && (preset < 100 || (!deposit && !canCredit(d)))) return;
      var box = document.createElement('div');
      box.className = 'prex-pts-friend prex-pts-nudge'; box.id = 'prex-pts-nudge'; box.setAttribute('role', 'dialog');
      function apply(code) { location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; }
      function view(step, err) {
        var title, desc, btn;
        if (reward) {
          title = 'You have a reward available'; desc = money(reward.amount, rc) + ' off code ' + reward.code; btn = 'Apply your ' + money(reward.amount, rc) + ' code';
        } else if (step === 'confirm') {
          title = 'Use ' + fmt(preset) + ' Points?';
          desc = deposit ? 'We\'ll create a ' + money(preset / 100, pc) + ' off code and apply it to this cart (store credit can\'t be used on deposit pre-orders).'
            : 'We\'ll add ' + creditMoney(preset / 100, d) + ' store credit to your account and take you to checkout to apply it.';
          btn = 'Confirm';
        } else if (step === 'busy') {
          title = 'Use ' + fmt(preset) + ' Points?'; desc = deposit ? 'Applying…' : 'Adding store credit…'; btn = '…';
        } else {
          title = pc !== CREDIT_CUR && !deposit ? 'You have ' + fmt(d.balance) + ' Points' : 'You have ' + money(d.balance / 100, pc) + ' in points';
          desc = fmt(d.balance) + ' Points, good for ' + (deposit ? money(d.balance / 100, pc) + ' off' : creditMoney(d.balance / 100, d) + ' store credit');
          btn = 'Use ' + fmt(preset) + ' pts for ' + (deposit ? money(preset / 100, pc) + ' off' : creditMoney(preset / 100, d) + ' credit');
        }
        box.innerHTML = '<button class="prex-pts-friend-x" data-nclose aria-label="Close prompt">' + ICON.close + '</button>' +
          '<div class="prex-pts-nudge-ico" aria-hidden="true">\uD83C\uDF81</div>' +
          '<div class="prex-pts-friend-title">' + esc(title) + '</div>' +
          '<div class="prex-pts-nudge-desc">' + esc(desc) + '</div>' +
          (err ? '<div class="prex-pts-friend-err">' + esc(err) + '</div>' : '') +
          '<button class="prex-pts-friend-btn is-on" data-ngo="' + (reward ? 'apply' : step === 'confirm' ? 'redeem' : 'ask') + '"' + (step === 'busy' ? ' disabled' : '') + '>' + esc(btn) + '</button>' +
          (step === 'confirm' ? '<p class="prex-pts-friend-note"><a class="prex-pts-link" href="#" data-nmore>Choose a different amount</a></p>' : '');
      }
      view('ask');
      box.addEventListener('click', function (e) {
        var go = e.target.closest('[data-ngo]');
        if (e.target.closest('[data-nclose]')) {
          try { sessionStorage.setItem('prex-pts-nudge-closed', '1'); } catch (err) {}
          box.remove();
        } else if (e.target.closest('[data-nmore]')) {
          e.preventDefault(); box.remove(); open('redeem');
        } else if (go) {
          var what = go.getAttribute('data-ngo');
          if (what === 'apply') return apply(reward.code);
          if (what === 'ask') return view('confirm');
          view('busy');
          (deposit ? api('redeem', { points: preset }).then(function (r) { apply(r.code); })
            : api('credit', { points: preset, currency: CREDIT_CUR }).then(function () { location.href = '/checkout'; }))
            .catch(function (err) { view('confirm', creditError(err)); });
        }
      });
      document.body.appendChild(box);
    }).catch(function () {});
  }
  cartNudge();

  // ── Cart drawer strip (Bin 2026-10-21, "结算时提示有多少积分"): the checkout pages can't be
  // customised on this plan, so the last place we own is the drawer's Checkout button. A compact
  // strip above it offers the same one click as the cart page: an unused code is applied, otherwise
  // a preset redeem (<= balance, <= subtotal in the points currency, <= 5,000 points) with one confirmation; the
  // code is applied and the customer lands on checkout. The drawer rebuilds its markup on every
  // cart change, so the strip is re-inserted on cart-drawer:refreshed / cart:change.
  function drawerNudge() {
    if (!me) return;
    try { if (sessionStorage.getItem('prex-pts-nudge-closed')) return; } catch (e) {}
    var group = document.querySelector('cart-drawer .cart-drawer__footer .button-group');
    if (!group || document.getElementById('prex-pts-drawer')) return;
    Promise.all([loadSummary(), fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; })])
      .then(function (res) {
      var d = res[0], cart = res[1];
      if (!cart || !cart.item_count || document.getElementById('prex-pts-drawer')) return;
      var reward = d.rewards[0];
      var onCart = (cart.discount_codes || []).map(function (c) { return String(c.code).toLowerCase(); });
      if (reward && onCart.indexOf(String(reward.code).toLowerCase()) >= 0) return;
      var subtotal = cartInPoints(cart.items_subtotal_price || cart.total_price || 0, d);
      var deposit = cartHasDeposit(cart); // store credit is blocked on deposit pre-orders: offer a code instead
      var preset = deposit ? Math.min(creditPreset(d.balance, subtotal), MAX_REDEEM) : creditPreset(d.balance, subtotal);
      var pc = cur(d), rc = reward ? reward.currency || pc : pc;
      if (!reward && (preset < 100 || (!deposit && !canCredit(d)))) return;
      var box = document.createElement('div');
      box.id = 'prex-pts-drawer'; box.className = 'prex-pts-drawer';
      function apply(code) { location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'; }
      function view(step, err) {
        var text, btn, what;
        if (reward) { text = 'You have a ' + money(reward.amount, rc) + ' off code waiting'; btn = 'Apply your ' + money(reward.amount, rc) + ' code'; what = 'apply'; }
        else if (step === 'confirm') { text = deposit ? 'Create a ' + money(preset / 100, pc) + ' off code from ' + fmt(preset) + ' Points and apply it? (Store credit can\'t be used on deposit pre-orders.)' : 'Turn ' + fmt(preset) + ' Points into ' + creditMoney(preset / 100, d) + ' store credit and go to checkout?'; btn = 'Confirm'; what = 'redeem'; }
        else if (step === 'busy') { text = deposit ? 'Applying\u2026' : 'Adding store credit\u2026'; btn = '\u2026'; what = 'busy'; }
        else { text = pc !== CREDIT_CUR && !deposit ? 'You have ' + fmt(d.balance) + ' Points' : 'You have ' + money(d.balance / 100, pc) + ' in points (' + fmt(d.balance) + ' pts)'; btn = 'Use ' + fmt(preset) + ' pts for ' + (deposit ? money(preset / 100, pc) + ' off' : creditMoney(preset / 100, d) + ' credit'); what = 'ask'; }
        box.innerHTML = '<span class="prex-pts-drawer-ico" aria-hidden="true">\uD83C\uDF81</span><span class="prex-pts-drawer-text">' + esc(text) +
          (err ? '<br><span class="prex-pts-drawer-err">' + esc(err) + '</span>' : '') + '</span>' +
          '<button type="button" class="prex-pts-drawer-btn" data-dgo="' + what + '"' + (what === 'busy' ? ' disabled' : '') + '>' + esc(btn) + '</button>' +
          (step === 'confirm' ? '<button type="button" class="prex-pts-drawer-x" data-dgo="cancel" aria-label="Cancel">\u00d7</button>'
            : '<button type="button" class="prex-pts-drawer-x" data-dclose aria-label="Hide">\u00d7</button>');
      }
      view('ask');
      box.addEventListener('click', function (e) {
        e.preventDefault();
        if (e.target.closest('[data-dclose]')) { try { sessionStorage.setItem('prex-pts-nudge-closed', '1'); } catch (err) {} box.remove(); return; }
        var go = e.target.closest('[data-dgo]');
        if (!go) return;
        var what = go.getAttribute('data-dgo');
        if (what === 'apply') return apply(reward.code);
        if (what === 'ask') return view('confirm');
        if (what === 'cancel') return view('ask');
        if (what === 'redeem') {
          view('busy');
          (deposit ? api('redeem', { points: preset }).then(function (r) { apply(r.code); })
            : api('credit', { points: preset, currency: CREDIT_CUR }).then(function () { location.href = '/checkout'; }))
            .catch(function (err) { view('confirm', creditError(err)); });
        }
      });
      group.parentNode.insertBefore(box, group);
    }).catch(function () {});
  }
  drawerNudge();
  document.addEventListener('cart-drawer:refreshed', function () { setTimeout(drawerNudge, 50); });
  document.addEventListener('cart:change', function () { var old = document.getElementById('prex-pts-drawer'); if (old) old.remove(); setTimeout(drawerNudge, 300); });

  window.PrexPoints = { open: open, close: close };
})();
